import fetch from 'services/request';
import { IApiCheckInHistoriesParams, IApiCheckInHistoriesSummaryParams, IApiHistoryClockInOut, IApiPrintCouponMarketing, IApiSyncWaitingToTicketV2, IFilterDataParams } from './types/api';
import moment from 'moment';
import { STAFF_CLOCK_IN_OUT_ACTIONS } from './constants';
import { IApiVoiceCallCustomerBody } from './types/waiting';
import { HOME_SORT_BY } from 'services/shop/constants';

const getWaitingList = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/check-in/get-list-waiting',
  });
};

const getSummaryData = (params: IFilterDataParams) => {
  return fetch({
    method: 'get',
    url: 'api/v1/check-in/dashboard',
    params,
  });
};

const getBillWaitingTicket = () => {
  return fetch({
    method: 'get',
    url: 'api/v1/bill/list-waiting-ticket',
  });
};

const doClockIn = (pin: number | string) => {
  return fetch({
    method: 'post',
    url: 'api/v1/staff/clock-in-out',
    body: {
      pin,
      action: STAFF_CLOCK_IN_OUT_ACTIONS.CLOCK_IN,
      currentDate: moment().format(),
    },
  });
};

const doClockOut = (pin: number | string) => {
  return fetch({
    method: 'post',
    url: 'api/v1/staff/clock-in-out',
    body: {
      pin,
      action: STAFF_CLOCK_IN_OUT_ACTIONS.CLOCK_OUT,
      currentDate: moment().format(),
      sourceType: 'POS',
    },
  });
};

const getStaffAvailable = (sort?: HOME_SORT_BY) => {
  return fetch({
    method: 'get',
    url: 'api/v1/staff/list-available-clock-in',
    params: sort
      ? {
        sort,
      }
      : undefined,
  });
};

const getHistoryClockInOut = (params: IApiHistoryClockInOut) => {
  return fetch({
    method: 'get',
    url: 'api/v1/staff/history-clock-in-out',
    params,
  });
};
const getListOpenTicket = () => {
  const now = moment().format('MM-DD-YYYY');
  return fetch({
    method: 'get',
    url: 'api/v1/bill/list-ticket-by-status',
    params: {
      status: 'OPEN_TICKET',
      startDate: now,
      endDate: now,
    },
  });
};

const removePendingTicket = (billId: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/bill/delete-ticket/${billId}`,
    autoToast: true,
  });
};

const removeWaitingTicket = (billId: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/check-in/delete-waiting-list/${billId}`,
    autoToast: true,
  });
};

const getListAvailableWorking = (sort?: HOME_SORT_BY) => {
  return fetch({
    method: 'get',
    url: '/api/v1/staff/list-available-working',
    params: sort
      ? {
        sort,
      }
      : undefined,
  });
};

const sortCheckIn = (ids: string[]) => {
  return fetch({
    method: 'post',
    url: '/api/v1/staff/sort-check-in',
    body: ids,
  });
};

const callVoiceNotification = (staffId: string) => {
  return fetch({
    method: 'post',
    url: `/api/v1/staff/voice-notification/${staffId}`,
  });
};

const syncWaitingToTicket = (staffId: string, checkInId: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/bill/sync-waiting-to-ticket',
    body: { staffId, checkInId },
  });
};
const syncWaitingToTicketV2 = (body: IApiSyncWaitingToTicketV2) => {
  return fetch({
    method: 'post',
    url: '/api/v1/bill/sync-waiting-to-ticket-v2',
    body,
  });
};
const voiceCustomer = (body: IApiVoiceCallCustomerBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/check-in/voice-customer-still-waiting',
    body,
  });
};

const walkInTicketChangeStaff = (id: string, staffId: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/check-in/update-staff-still-waiting',
    body: { id, staffId },
  });
};

const getHomeBackground = () => {
  return fetch({
    method: 'get',
    url: '/api/v1/setting/home-background',
  });
};

const changeHomeBackground = (color: string) => {
  return fetch({
    method: 'post',
    url: '/api/v1/setting/home-background',
    body: { value: color },
  });
};

const revertWorkingOnToWaiting = (billId: string) => {
  return fetch({
    method: 'post',
    url: `/api/v1/bill/revert-ticket-to-waiting/${billId}`,
  });
};

const voiceReminderTip = (staffId: string) => {
  return fetch({
    method: 'post',
    url: `/api/v1/staff/voice-reminder-tip/${staffId}`,
  });
};

const getTimeTracker = (startDate: string, endDate: string, staffId: string) => {
  const params = {
    startDate,
    endDate,
    staffId,
    page: 1,
    size: 1000,
  };
  return fetch({
    method: 'get',
    url: '/api/v1/staff/history-clock-in-out',
    params,
  });
};

const getNotifications = () => fetch({
  method: 'get',
  url: '/api/v1/shop/system-notification',
});

const deleteNotification = (id: string) => fetch({
  method: 'delete',
  url: `/api/v1/shop/delete-system-notification/${id}`,
});

const readNotification = (id: string) => fetch({
  method: 'post',
  url: `/api/v1/shop/read-system-notification/${id}`,
});

const countUnreadNotification = () => fetch({
  method: 'get',
  url: '/api/v1/shop/count-unread-system-notification',
});

const getLastTicket = () => fetch({
  method: 'get',
  url: '/api/v1/bill/last-ticket',
});

const getHomeReportDiscount = () => fetch({
  method: 'get',
  url: '/api/v1/report/discount',
});

const getCouponMarketing = (type = 'PRINT_MANUAL_MARKETING') => fetch({
  method: 'get',
  url: `/api/v1/coupon/list-by-type/${type}`,
});

const getCheckInHistories = (params: IApiCheckInHistoriesParams) => fetch({
  method: 'get',
  url: '/api/v1/check-in/histories',
  params,
});

const getCheckInHistoriesSummary = (params: IApiCheckInHistoriesSummaryParams) => fetch({
  method: 'get',
  url: '/api/v1/check-in/summary',
  params,
});

// /api/v1/coupon/print-manual
const printCouponMarketing = (body: IApiPrintCouponMarketing) => fetch({
  method: 'post',
  url: '/api/v1/coupon/print-manual',
  body,
});

// /api/v1/staff/working-order
const reorderStaffWorking = (body: string[]) => fetch({
  method: 'post',
  url: '/api/v1/staff/working-order',
  body,
});

const removeMultipleWaitingTicket = (ids: string[]) => {
  return fetch({
    method: 'delete',
    url: '/api/v1/check-in/delete-multiple-waiting-list',
    configs: {
      data: ids,
    },
  });
};

const removeMultipleTicket = (ids: string[]) => {
  return fetch({
    method: 'post',
    url: '/api/v1/bill/delete-multiple-ticket',
    body: ids,
  });
};

// /api/v1/appointment/group-by-time
const getAptGroupByTime = () => fetch({
  method: 'get',
  url: '/api/v1/appointment/group-by-time',
});

// api/v1/appointment/send-sms-reminder
const aptSendSMSReminder = (customerId: string, message?: string) => fetch({
  method: 'post',
  url: '/api/v1/appointment/send-sms-reminder',
  body: { message, customerId },
});

// api/v1/appointment/check-in/{customerId}
const aptCheckIn = (customerId: string) => fetch({
  method: 'post',
  url: `/api/v1/appointment/check-in/${customerId}`,
});

const getListStaffAttendance = () => fetch({
  method: 'get',
  url: '/api/v1/staff/list-clock-in-out',
});

const getAppointmentSlideHome = () => fetch({
  method: 'get',
  url: '/api/v1/appointment/slide-home',
});

const updateStatusWorking = (staffId: string, status: string) => fetch({
  method: 'post',
  url: '/api/v1/staff/update-status-working',
  body: { staffId, status },
});

const voiceNextTurn = (billId: string, staffId: string) => fetch({
  method: 'post',
  url: '/api/v1/staff/voice-next-turn',
  body: { billId, staffId },
});

const userApis = {
  getWaitingList,
  getSummaryData,
  getBillWaitingTicket,
  doClockIn,
  doClockOut,
  getStaffAvailable,
  getHistoryClockInOut,
  getListOpenTicket,
  removePendingTicket,
  removeWaitingTicket,
  getListAvailableWorking,
  sortCheckIn,
  callVoiceNotification,
  syncWaitingToTicket,
  syncWaitingToTicketV2,
  voiceCustomer,
  walkInTicketChangeStaff,
  getHomeBackground,
  changeHomeBackground,
  revertWorkingOnToWaiting,
  voiceReminderTip,
  getTimeTracker,
  getNotifications,
  deleteNotification,
  readNotification,
  countUnreadNotification,
  getLastTicket,
  getHomeReportDiscount,
  getCouponMarketing,
  getCheckInHistories,
  getCheckInHistoriesSummary,
  printCouponMarketing,
  reorderStaffWorking,
  removeMultipleWaitingTicket,
  removeMultipleTicket,
  getAptGroupByTime,
  aptSendSMSReminder,
  aptCheckIn,
  getListStaffAttendance,
  getAppointmentSlideHome,
  updateStatusWorking,
  voiceNextTurn,
};

export default userApis;
